/**
 * Rune Stage Route
 *
 * Triggers loading of the rune stage when this route becomes active.
 * The actual canvas is in the parent layout (ux.tsx).
 */

import { createFileRoute } from "@tanstack/react-router";
import { useLoadStageOnMount } from "../ux";

export const Route = createFileRoute("/_immersive/demo/3d/ux/rune")({
  component: RuneStageRoute,
});

function RuneStageRoute() {
  useLoadStageOnMount("rune");
  return null;
}
